import React from "react";

export default function FormRequiredMark() {
    return <span className="form-label-required" aria-hidden="true"> *</span>;
}
